import { Classes } from "../../theme/Classes"

export const Box = ({ children, display = "column", width='100%' }) => {

    return (
        <>
            {display === "columnStart" &&
                <div style={{ width: width }}>
                    <div style={Classes.Box.ColumnStart}>
                        {children}
                    </div>
                </div>
            }
            {display === "columnCenter" &&
                <div style={{ width: width }}>
                    <div style={Classes.Box.ColumnCenter}>
                        {children}
                    </div>
                </div>
            }
            {display === "rowStart" &&
                <div style={{ width: width }}>
                    <div style={Classes.Box.RowStart}>
                        {children}
                    </div>
                </div>
            }
             {display === "rowEnd" &&
                <div style={{ width: width }}>
                    <div style={Classes.Box.RowEnd}>
                        {children}
                    </div>
                </div>
            }
            {display === "rowCenter" &&
                <div style={{ width: width }}>
                    <div style={Classes.Box.RowCenter}>
                        {children}
                    </div>
                </div>
            }
             {display === "rowSpaceBetween" &&
                <div style={{ width: width }}>
                    <div style={Classes.Box.RowSpaceBetween}>
                        {children}
                    </div>
                </div>
            }

        </>

    )
}